import React from "react";
import { withRoomConsumer } from "../context";
import Loading from "./Loading";
import RoomFilter from "./RoomFilter";
import RoomsList from "./RoomsList";

function RoomContainer({context}) {
    const { loading, sortedRooms, rooms } = context;

    if(loading) {
       return <Loading />
    }
    return (
        <>
          <RoomFilter rooms={rooms}/>
          <RoomsList rooms={sortedRooms}/>
        </>
    );
};

export default withRoomConsumer(RoomContainer)
